/**
 * @param {LangService} langService
 *
 * @return {function(string, object): string}
 */
const langFilter = (langService) => (key, parameters) => langService.getText(key, parameters);

module.exports = langFilter;
